export default "__VITE_ASSET__wrKijD1X__"